import type { ComponentPropsWithoutRef } from 'react'

export const UnorderedList: React.FC<ComponentPropsWithoutRef<'ul'>> = (
  props,
) => {
  return (
    <ul
      className="unordered-list ml-4 list-outside list-disc pt-3 marker:text-left marker:text-black [&>li]:pl-2 [.unordered-list_&]:pt-0"
      {...props}
    />
  )
}
